import type { PropsWithChildren } from "react"
import { useEffect, useMemo } from "react"
import { IntlProvider } from "react-intl"
import type { TranslationsContextProps } from "./TranslationsContext"
import { TranslationsContext } from "./TranslationsContext"
import { useDirection } from "./useDirection"
import { useTranslations } from "./useTranslations"

interface TranslationsProviderProps extends PropsWithChildren {
	additionalTranslations?: Record<string, string>
	locale: string
}

export const TranslationsProvider = ({ additionalTranslations, children, locale }: TranslationsProviderProps) => {
	const { translations, translationsLoaded } = useTranslations(locale)
	const direction = useDirection(locale)

	useEffect(() => {
		document.dir = direction
	}, [direction])

	const value: TranslationsContextProps = useMemo(
		() => ({
			isLoaded: translationsLoaded,
			translations,
		}),
		[translations, translationsLoaded],
	)

	return (
		<TranslationsContext.Provider value={value}>
			<IntlProvider
				locale={locale}
				messages={{
					...additionalTranslations,
					...translations,
				}}
			>
				{children}
			</IntlProvider>
		</TranslationsContext.Provider>
	)
}
